'use client';

import { c as _c } from "react/compiler-runtime";
import './homepage-greeting.scss';
import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';
import { useHomepageGreeting } from './homepage-greeting.logic.ts';
export const HomepageGreeting = () => {
  const $ = _c(7);
  const {
    preFlagAnchor,
    flagAnchor,
    hasGreetingError,
    isLoadingGreeting,
    name,
    selectedLanguage,
    subtitle
  } = useHomepageGreeting();
  if (hasGreetingError) {
    return null;
  }
  let t0;
  if ($[0] !== flagAnchor || $[1] !== isLoadingGreeting || $[2] !== name || $[3] !== preFlagAnchor || $[4] !== selectedLanguage || $[5] !== subtitle) {
    t0 = <div className="HomepageGreeting flex flex-col gap-snug-md w-full py-comfy-sm">{isLoadingGreeting ? <div className="flex flex-col gap-snug-md" aria-label="Loading greeting" aria-busy="true"><Skeleton height={40} width="min(100%, 18rem)" /><Skeleton height={20} width="min(100%, 24rem)" /></div> : <><h1 className="heading-sm heading-neutral-amplified md:heading-md">{preFlagAnchor}<span className="HomepageGreeting__flagAnchor"><span className="HomepageGreeting__flag" aria-hidden="true">{selectedLanguage.flag}</span>{flagAnchor}{","}</span>{name ? ` ${name}!` : "!"}</h1><p className="body-sm body-neutral-mild">{subtitle}</p></>}</div>;
    $[0] = flagAnchor;
    $[1] = isLoadingGreeting;
    $[2] = name;
    $[3] = preFlagAnchor;
    $[4] = selectedLanguage;
    $[5] = subtitle;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  return t0;
};